import type { SVGProps } from 'react';

const FavoriteGameIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <g transform="translate(-305.000000, -201.000000)">
                <path d="M319.520545,203.654334 C318.337139,201.705018 316.44073,201.781691 315.378622,202.35479 C314.175098,203.004562 313.583394,203.654334 312.991691,204.304106 C312.399988,203.654334 311.785208,202.805082 310.624878,202.35479 C309.508925,201.921392 307.666361,201.705018 306.482954,203.654334 C305.299547,206.253422 306.482954,208.852509 307.965171,210.174145 C309.424311,211.474988 311.582254,213.83366 312.991691,216 C314.401128,213.83366 316.587472,211.486035 318.038329,210.174145 C319.500428,208.852509 320.703952,206.253422 319.520545,203.654334" />
            </g>
        </g>
    </svg>
);

export default FavoriteGameIcon;
